import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconModule } from 'src/app/components/icon/icon.module';
import { TooltipModule } from 'src/app/components/tooltip/tooltip.module';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../shared/shared.module';

import { TypesService } from 'src/app/services/types.service';
import { CompanyContentComponent } from './company-content/company-content.component';
import { ItemButtonComponent } from './item-button/item-button.component';
import { ItemContentComponent } from './item-content/item-content.component';
import { MenuComponent } from './menu.component';
import { BadgeUpperModule } from 'src/app/components/badge-upper/badge-upper.module';

@NgModule({
  imports: [
    CommonModule,
    IconModule,
    TooltipModule,
    RouterModule,
    SharedModule,
    BadgeUpperModule,
  ],
  declarations: [
    MenuComponent,
    CompanyContentComponent,
    ItemButtonComponent,
    ItemContentComponent,
  ],
  exports: [MenuComponent],
  providers: [TypesService],
})
export class MenuModule {}
